const toString = Object.prototype.toString
const isEnumerable = Object.prototype.propertyIsEnumerable
const getSymbols = Object.getOwnPropertySymbols

const assignSymbols = (target, ...args) => {
  if (!isObject(target)) {
    throw new TypeError('expected the first argument to be an object')
  }

  if (0 === args.length || 'function' !== typeof Symbol || 'function' !== typeof getSymbols) {
    return target
  }

  for (const arg of args) {
    const names = getSymbols(arg)

    for (const key of names) {
      if (isEnumerable.call(arg, key)) {
        target[key] = arg[key]
      }
    }
  }
  return target
}

function isObject(val) {
  return 'function' === typeof val || '[object Object]' === toString.call(val) || Array.isArray(val)
}

const assignDeep = (_target, ...args) => {
  let target = _target
  let i = 0
  if (isPrimitive(target)) target = args[i++]
  if (!target) target = {}
  for (; i < args.length; i++) {
    if (isObject(args[i])) {
      for (const key of Object.keys(args[i])) {
        if (isObject(target[key]) && isObject(args[i][key])) {
          assignDeep(target[key], args[i][key])
        } else {
          target[key] = args[i][key]
        }
      }
      assignSymbols(target, args[i])
    }
  }
  return target
}

function isPrimitive(val) {
  return 'object' === typeof val ? null === val : 'function' !== typeof val
}

export default assignDeep
